// Wrapper component that shows desktop or mobile version based on screen size.
import AttendanceDesktop from './AttendanceDesktop';
import AttendanceMobile from './AttendanceMobile';

export default function Attendance() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <AttendanceDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <AttendanceMobile />
      </div>
    </>
  );
}
